import { jsx as t, jsxs as l } from "react/jsx-runtime";
import { O as n, P as f, C as d, a as r, T as c, D as m, R as u, b as x } from "./index-Bxq-rK0V.js";
import { a as y } from "./react-icons.esm-CDi78UIJ.js";
import { $ as s } from "./utils-CTvPli9r.js";
import { forwardRef as i } from "react";
const O = u, P = x, N = f, R = r, p = i(({ className: a, ...e }, o) => /* @__PURE__ */ t(
  n,
  {
    ref: o,
    className: s(
      "fixed inset-0 z-50 bg-black/80  data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0",
      a
    ),
    ...e
  }
));
p.displayName = n.displayName;
const D = i(({ className: a, children: e, ...o }, g) => /* @__PURE__ */ l(N, { children: [
  /* @__PURE__ */ t(p, {}),
  /* @__PURE__ */ l(
    d,
    {
      ref: g,
      className: s(
        "fixed left-[50%] top-[50%] z-50 grid w-full max-w-lg translate-x-[-50%] translate-y-[-50%] gap-4 border bg-background p-6 shadow-lg duration-200 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[state=closed]:slide-out-to-left-1/2 data-[state=closed]:slide-out-to-top-[48%] data-[state=open]:slide-in-from-left-1/2 data-[state=open]:slide-in-from-top-[48%] sm:rounded-lg",
        a
      ),
      ...o,
      children: [
        e,
        /* @__PURE__ */ l(r, { className: "absolute right-4 top-4 rounded-sm opacity-70 ring-offset-background transition-opacity hover:opacity-100 focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 disabled:pointer-events-none data-[state=open]:bg-accent data-[state=open]:text-muted-foreground", children: [
          /* @__PURE__ */ t(y, { className: "size-4" }),
          /* @__PURE__ */ t("span", { className: "sr-only", children: "Close" })
        ] })
      ]
    }
  )
] }));
D.displayName = d.displayName;
const b = ({ className: a, ...e }) => /* @__PURE__ */ t("div", { className: s("flex flex-col space-y-1.5 text-center sm:text-left", a), ...e });
b.displayName = "DialogHeader";
const h = ({ className: a, ...e }) => /* @__PURE__ */ t(
  "div",
  {
    className: s("flex flex-col-reverse sm:flex-row sm:justify-end sm:space-x-2", a),
    ...e
  }
);
h.displayName = "DialogFooter";
const v = i(({ className: a, ...e }, o) => /* @__PURE__ */ t(
  c,
  {
    ref: o,
    className: s("text-lg font-semibold leading-none tracking-tight", a),
    ...e
  }
));
v.displayName = c.displayName;
const C = i(({ className: a, ...e }, o) => /* @__PURE__ */ t(
  m,
  {
    ref: o,
    className: s("text-sm text-muted-foreground", a),
    ...e
  }
));
C.displayName = m.displayName;
export {
  O as Dialog,
  R as DialogClose,
  D as DialogContent,
  C as DialogDescription,
  h as DialogFooter,
  b as DialogHeader,
  p as DialogOverlay,
  N as DialogPortal,
  v as DialogTitle,
  P as DialogTrigger
};
//# sourceMappingURL=dialog.js.map
